/**
* Copyright 2012-2019, Plotly, Inc.
* All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/

/*
 * Taken from https://github.com/plotly/plotly.js/blob/920b7bce5ca252469be5aaf9e06224eac3926073/src/lib/notifier.js
 */


'use strict';

import {select} from 'd3-selection'
import isNumeric from 'fast-isnumeric';

const NOTEDATA = [];

/**
 * notifier
 * @param {String} text The person's user name
 * @param {Number} [delay=1000] The delay time in milliseconds
 *          or 'long' which provides 3000 ms delay time.
 * @return {undefined} this function does not return a value
 */
export default function notifier(text, displayLength) {
    if(NOTEDATA.indexOf(text) !== -1) {
        return;
    }

    NOTEDATA.push(text);

    let ts = 1000;
    if(isNumeric(displayLength)) {
        ts = displayLength;
    }
    else if(displayLength === 'long') {
        ts = 3000;
    }

    const notifierContainer = select('body')
        .selectAll('.plotly-notifier')
        .data([0]);
    notifierContainer.enter()
        .append('div')
        .classed('plotly-notifier', true);

    const notes = notifierContainer.selectAll('.notifier-note').data(NOTEDATA);

    function killNote(transition) {
        transition
            .duration(700)
            .style('opacity', 0)
            .each('end', function(thisText) {
                const thisIndex = NOTEDATA.indexOf(thisText);
                if(thisIndex !== -1) { NOTEDATA.splice(thisIndex, 1); }
                select(this).remove();
            });
    }

    notes.enter().append('div')
        .classed('notifier-note', true)
        .style('opacity', 0)
        .each(function(thisText) {
            const note = select(this);

            note.append('button')
                .classed('notifier-close', true)
                .html('&times;')
                .on('click', function() {
                    note.transition().call(killNote);
                });

            const p = note.append('p');
            const lines = thisText.split(/<br\s*\/?>/g);
            for(let i = 0; i < lines.length; i++) {
                if(i) { p.append('br'); }
                p.append('span').text(lines[i]);
            }

            note.transition()
                    .duration(700)
                    .style('opacity', 1)
                .transition()
                    .delay(ts)
                    .call(killNote);
        });
};
